const STORAGE_KEY = 'forum_watchlist';

export function getWatchlist(): string[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((id) => typeof id === 'string') : [];
  } catch {
    return [];
  }
}

export function isInWatchlist(forumId: string): boolean {
  return getWatchlist().includes(forumId);
}

export function toggleWatchlist(forumId: string): boolean {
  const list = getWatchlist();
  const next = list.includes(forumId)
    ? list.filter((id) => id !== forumId)
    : [...list, forumId];
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  window.dispatchEvent(new CustomEvent('watchlist-changed'));
  return next.includes(forumId);
}
